import * as _ from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dataFilterName',
})
export class DataFilterNamePipe implements PipeTransform {

    transform(array: any[], query: string): any {
        if (query) {
            return _.filter(array, row => row.name.toLowerCase().indexOf(query.toLowerCase()) > -1);
        }
        return array;
    }
}



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/pipes/dataFilterName/data-filter-name.pipe.ts